import React from 'react';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { Form } from 'react-final-form';
import PropTypes from '../../types';
import { Content } from '../../infrastructure/content';
import BusinessType from './components/BusinessType';
import Submit from '../../components/Submit';

const BusinessTypePage = ({ saveBusinessTypeForm, getBusinessData }) => (
  <Form
    onSubmit={saveBusinessTypeForm}
    initialValues={getBusinessData}
    render={({ handleSubmit }) => (
      <form onSubmit={handleSubmit}>
        <div>
          <Content>
            {({ businessTypePageTitle = '' }) => <PageHeading>{businessTypePageTitle}</PageHeading>}
          </Content>

          <BusinessType />

          <Submit />
        </div>
      </form>
    )}
  />
);

BusinessTypePage.propTypes = {
  bankId: PropTypes.bankId.isRequired,
  saveBusinessTypeForm: PropTypes.func.isRequired
};

export default BusinessTypePage;
